"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
let version = '0.0.0';

try {
  version = "3.2.0"; // eslint-disable-line no-undef
} catch (e) {}

var _default = version;
exports.default = _default;
//# sourceMappingURL=version.js.map